<template>
    <div class="container">

    	<div v-if="step == 'og_meta'" class="pt-3">
    		
    		<h3 class="text-center mb-2">Deck share preview</h3>
    				<p class="text-center mb-4">Make sure your deck is ready to be shared on social media.</p>

    		<div class="row">
    			<div class="col">

	    			<div class="share-preview">
							<div class="sms-message">
								<div class="sms-img-wrap" :style="'background-image:url('+og_meta.image+');'"></div>
								<div class="sms-domain">{{ og_meta.domain }}</div>
								<div class="sms-title">{{ og_meta.title }}</div>
								<div class="sms-description">{{ og_meta.description }}</div>
							</div>
				
						    <b-modal id="crop-ogimage-modal" ref="crop-ogimage-modal" title="Choose Share Image" ok-only ok-title="Done" ok-varient="outline-primary" body-class="pt-0">
						      <og-image-crop input-id="og_image" name="og_image" :image="og_meta.image" @change="setDeckOgImage($event)"></og-image-crop>
						    </b-modal>
						</div>

					</div>
					<div class="col">
						<b-form-group label-cols-sm="2" label="Image" label-align-sm="right" label-for="og_title">
							<b-button @click="launchSetOGimage">Update Share Image</b-button>
						</b-form-group>

						<b-form-group label-cols-sm="2" label="Title" label-align-sm="right" label-for="og_title">
							<b-form-input  
								v-model="og_meta.title"
								id="og_title"
							></b-form-input>
						</b-form-group>
						<b-form-group label-cols-sm="2" label="Description" label-align-sm="right" label-for="og_description">
							<b-form-textarea  
								v-model="og_meta.description"
								id="og_description"
								rows="6"
							></b-form-textarea>
						</b-form-group>

					</div>
				</div>
				<div class="d-flex justify-content-end">
				  <b-button variant="primary" class=""  @click="saveOG()">Next</b-button>
				</div>


    	</div>

    	<!-- Choose Send Method -->
    	<div v-if="step == 'send_method'" class="pt-3">
                     
    		<h3 class="text-center mb-4">Ready to share your deck with the world?</h3>

    		<b-form-group class="text-center">
            	<b-button variant="primary" @click="shareSocialLink()" value="single" title="Publish and generate a link to your SizzleDeck ">Click Here to Generate a Link to Your SizzleDeck</b-button>
            </b-form-group>

            <hr />


            <h5  class="text-center mb-4 pt-3">Or if you prefer, you can send your SizzleDeck by Email or SMS to multiple contacts...</h5>

            <b-form-group class="text-center">
            	<!-- 
				<b-form-group label-cols-sm="12" label-align-sm="left" label="If you are using personalisations in your deck or you want to send your deck to specific people:">
            	<b-button variant="outline-primary" @click="selectSendMethod('single'); goToStep('choose_contact')" value="single" title="Send to a Single Recipient">Send my SizzleDeck to a Single Recipient</b-button>

            	 Or -->

            	<b-button v-if="!loaded_mailinglists"
              	variant="outline-primary" 
              	@click="showNoty('warning','Loading Mailing Lists. Please wait...',2000)" 
              	value="campaign"
				title="Loading Mailing Lists. Please wait..."
				:disabled=true
          		>Loading mailing lists...</b-button> 
	          	
            	<b-button v-if="loaded_mailinglists && mailinglists.length >= 1"
              	variant="outline-primary" 
              	@click="selectSendMethod('campaign');goToStep('send_via');"
              	value="campaign"
				title="Send My SizzleDeck to a Mailing List" 
          		>Send My SizzleDeck to a Mailing List</b-button> 

            	<b-button v-if="loaded_mailinglists && mailinglists.length == 0"
              	variant="outline-primary" 
              	@click="showNoMailinglistsError()"
              	value="campaign"
				title="Send My SizzleDeck to a Mailing List" 
          		>Send My SizzleDeck to a Mailing List</b-button> 

            </b-form-group>            

   				<div class="d-flex justify-content-start">
				  <b-button variant="primary" class=""  @click="goToStep('og_meta')">Back</b-button>
				</div>

        </div>

        <!-- Choose Contact (Single Send) -->
        <div v-if="step == 'choose_contact'">

			<b-tabs content-class="mt-3">
				<b-tab class="pb-3" title="Choose Existing Contact" active>
				  <bootstrap-table-deck-send-contacts @selectContact="selectContact"></bootstrap-table-deck-send-contacts>
				</b-tab>
				<b-tab title="Add a New Contact">

					<b-form @submit="addContact">
						<b-form-group label-cols-sm="2" label="First Name:" label-align-sm="right" label-for="first-name">
							<b-form-input  
								v-model="addcontactform.first_name"
								id="first-name"
							></b-form-input>
						</b-form-group>
						<b-form-group label-cols-sm="2" label="Last Name:" label-align-sm="right" label-for="last-name">
							<b-form-input 
								v-model="addcontactform.last_name"
								id="last-name"  
							></b-form-input>
						</b-form-group>
						<b-form-group label-cols-sm="2" label="Company Name:" label-align-sm="right" label-for="company-name">
							<b-form-input 
								v-model="addcontactform.company_name"
								id="company-name" 								
							></b-form-input>
						</b-form-group>
						<b-form-group label-cols-sm="2" label="Email Address:" label-align-sm="right" label-for="email">
							<b-form-input 
								v-model="addcontactform.email" 
								id="email"
								type="email"
								></b-form-input>
						</b-form-group>
						<b-form-group label-cols-sm="2" label="Mobile Number:" label-align-sm="right" label-for="phone">
							<vue-tel-input 
								v-model="addcontactform.telephone" 
								placeholder="" 
								mode="international"
							></vue-tel-input>
						</b-form-group>      

						<b-button variant="primary" class="float-right" type="submit">Add Contact</b-button>
					</b-form>

				</b-tab>
				<b-tab v-if="use_capsule" class="pb-3" title="Select Capsule Contact">
				    <bootstrap-table-deck-send-capsule-contacts @selectCapsuleContact="selectCapsuleContact"></bootstrap-table-deck-send-capsule-contacts>
				</b-tab>
			</b-tabs>
			<b-button variant="secondary" @click="goToStep('send_method')">Back</b-button>
       	</div>

       	<!-- Choose Mailing Lists -->
        <div v-if="step == 'choose_mailinglist'">

			<b-form-group label="Select Mailing List(s) you wish to send to:">
			<b-form-checkbox
				v-for="mailinglist in mailinglists"
				v-model="selected_mailinglists"
				:key="mailinglist.id"
				:value="mailinglist.id"
				name="mailinglists[]">
				{{ mailinglist.name }} ({{ mailinglist.size_minus_suppressed }})
			</b-form-checkbox>
			</b-form-group>

			<b-button v-show="send_via === 'both'" variant="secondary" @click="goToStep('compose_email')">Back</b-button>
			<b-button v-show="send_via === 'sms'" variant="secondary" @click="goToStep('compose_sms')">Back</b-button>
		  	<b-button v-show="send_via === 'email'" variant="secondary" @click="goToStep('compose_email')">Back</b-button>

			<b-button variant="primary" class="float-right" @click="selectMailingLists()">Next</b-button>
        </div>
       	<!-- Send Via -->
       	<div v-if="step == 'send_via'">

			<b-form-group label-cols-sm="2" label-align-sm="right" label="Send this deck via:">


			  <b-button 
			  	variant="primary" 
			  	@click="selectSendVia('email')"
			  	v-bind:disabled="(send_method == 'single' && !contact.email) || !selected_email_template" 
			  	v-bind:title="(send_method == 'single' && !contact.email) ? 'Not available as contact does not have an email address' : 'Send via Email Only'" 
			  >Email Only</b-button>

			  <b-button
			  	variant="primary" 
			  	@click="selectSendVia('sms')"
			  	v-bind:disabled="(send_method == 'single' && !contact.telephone )" 
			  	v-bind:title="(send_method == 'single' && !contact.telephone ) ? 'Not available as contact does not have a mobile number' : 'Send via SMS'" 
			  >SMS Only</b-button>
 

			  <b-button 
			  	variant="primary" 
			  	@click="selectSendVia('both')" 
			  	v-bind:disabled="(send_method == 'single' && (!contact.email || !contact.telephone) ) || !selected_email_template" 
			  	v-bind:title="(send_method == 'single' && (!contact.email || !contact.telephone) ) ? 'Not available as contact does not have both an email address and mobile number' : 'Send via Email and SMS'" 
			  >Email & SMS</b-button>

			  <b-button
			  	variant="primary" 
			  	@click="shareContactLink()"
			  	v-if="send_method == 'single'" 
			  >Share Link</b-button>

			  <!-- <b-button v-if="send_method == 'campaign'" variant="primary" @click="goToStep('show_link')" title="Share a link">Share a link</b-button> -->

			</b-form-group>
			<div>              
              <b-button v-if="send_method == 'single'" variant="secondary" @click="goToStep('choose_contact')">Back</b-button>
              <b-button v-if="send_method == 'campaign'" variant="secondary" @click="goToStep('send_method')">Back</b-button>
			</div>
       	</div>

       	<!-- Compose SMS //border rounded mx-auto w-100 -->
       	<div v-if="step == 'compose_sms'">

            <b-form-group class="w-50 mx-auto" label="SMS Message:">
                <b-form-textarea rows="3" class=" mx-auto" v-model="sms.message"></b-form-textarea>
                <p v-if="sms.message" class=""><small class="text-muted">{{ 'This is the accompanying text message your recipient will see when they receive your SizzleDeck on their mobile phone. Sending this SMS will use '+ Math.ceil(sms.message.length / 120)*parseInt(sms_credit_value) +' credit' }}<span v-if="parseInt(sms_credit_value) > 1">s</span><span v-if="send_method == 'campaign'"> per recipient</span>.</small></p>
            </b-form-group>
			
			<div>
				<b-button variant="secondary" @click="goToStep('send_via')">Back</b-button>
				<!--<b-button v-if="send_method == 'single'" variant="secondary" @click="goToStep('choose_contact')">Back</b-button>
				<b-button v-if="send_method == 'campaign'" variant="secondary" @click="goToStep('choose_mailinglist')">Back</b-button> -->

				<b-button variant="primary" class="float-right" @click="saveSMS()">Next</b-button>
            </div>
       	</div>

       	<!-- Compose Email -->
       	<div v-if="step == 'compose_email'">

       		<div class="row">
       		<div class="col">
       			<form ref="emailpreviewform" :action="'/email/preview/'+selected_email_template" method="POST" target="emailPreview">
       				<!-- d-none to hide temporarily -->
	       		<b-form-group class="mx-auto d-none" label="Select an Email Template:">
				<b-form-select
					:options="email_templates"
					v-model="selected_email_template"
					value-field="id"
	      			text-field="name"
					>
				</b-form-select>
				</b-form-group>

				<b-form-group class="mx-auto" label="Email Subject">
				  <b-input name="data[subject]" type="text" v-model="email.subject"></b-input>
				</b-form-group>

				<b-form-group v-if="email.layout.includes('*|PREHEADER|*')" class="mx-auto" label="Email Preheader">
				  <b-input name="data[preheader]" type="text" v-model="email.preheader"></b-input>
				</b-form-group>

				<b-form-group v-if="email.layout.includes('*|BODY|*')" class="mx-auto" label="Email Message">
				  <tiptap v-model="email.body"></tiptap>
				  <input name="data[body]" type="hidden" v-model="email.body"></input>
				</b-form-group>

				<b-form-group v-if="email.layout.includes('*|BUTTON|*')" class="mx-auto" label="Button Text">
				  <b-input name="data[button]" class="w-25" type="text" v-model="email.button"></b-input>
				</b-form-group>

				<b-form-group v-if="email.layout.includes('*|FOOTER|*')" class="mx-auto" label="Email Footer">
		          <tiptap v-model="email.footer"></tiptap>
				  <input name="data[footer]" type="hidden" v-model="email.footer"></input>				  
				</b-form-group>

				<b-form-group v-if="email.layout.includes('*|CUSTOM_1|*')" class="mx-auto" label="Custom Field 1">
		          <tiptap v-model="email.footer"></tiptap>
				  <input name="data[custom_1]" type="hidden" v-model="email.custom_1"></input>				  
				</b-form-group>

				<b-form-group v-if="email.layout.includes('*|CUSTOM_2|*')" class="mx-auto" label="Custom Field 2">
		          <tiptap v-model="email.footer"></tiptap>
				  <input name="data[custom_2]" type="hidden" v-model="email.custom_2"></input>				  
				</b-form-group>

				<b-form-group v-if="email.layout.includes('*|CUSTOM_3|*')" class="mx-auto" label="Custom Field 3">
		          <tiptap v-model="email.footer"></tiptap>
				  <input name="data[custom_3]" type="hidden" v-model="email.custom_3"></input>				  
				</b-form-group>

				<b-form-group v-if="email.layout.includes('*|CUSTOM_4|*')" class="mx-auto" label="Custom Field 4">
		          <tiptap v-model="email.footer"></tiptap>
				  <input name="data[custom_4]" type="hidden" v-model="email.custom_4"></input>				  
				</b-form-group>
				
				<input type="hidden" name="_token" :value="csrf">

				<input type="hidden" name="contact" :value="contact_id">
				<input type="hidden" name="deck" :value="deckid">

				</form>

			</div>
			<div class="col">

				<label>Preview</label>
				<fieldset class="border rounded" style="height: calc(100% - 47px);">
				<div class="bg-light border-bottom">
					<div class="px-2 pt-2" v-if="email.from_email"><strong>{{ email.from_name }}</strong> &#60;{{ email.from_email }}&#62;</div>
					<div class="px-2">{{ rendered_string['email_subject'] }}</div>
					<div class="px-2" v-if="email.body"><span class="text-muted">{{ email.preheader ? rendered_string['email_preheader'].substring(0, 63) : rendered_string['email_body'].replace(/(<([^>]+)>)/gi, "").substring(0, 63) }}</span></div>
				</div>
				<iframe ref="emailPreviewIframe" id="emailPreview" name="emailPreview" @load="initalLoadEmailPreview" class="border-0 p-2 d-block w-100" style="height: calc(100% - 75px)"></iframe>
				</fieldset>
			</div>
			</div>

<div class="mb-3 mx-auto"><small class="text-muted">{{ 'This is the accompanying email message your recipient will see when they receive your SizzleDeck. Sending this email will use '+ parseInt(email_credit_value) +' credit' }}<span v-if="parseInt(email_credit_value) > 1">s</span><span v-if="send_method == 'campaign'"> per recipient</span>.</small></div>

				<div class="d-flex justify-content-between">
				  <b-button v-show="send_via === 'both'" variant="secondary" @click="goToStep('compose_sms')">Back</b-button>
				  <b-button v-show="send_via === 'email'" variant="secondary" @click="goToStep('send_via')">Back</b-button>

				  <b-button variant="primary" class=""  @click="saveEmail()">Next</b-button>
				</div>

       	</div>

        <!-- Display Link -->
        <div v-if="step == 'show_social_link'">
            
              <b-form-group label="Link" description="This is the link to your SizzleDeck. You can share this link via email, social media or however you like. After this SizzleDeck has been published, this link will be available in the results area.">
              	<b-input-group>
					<b-input readonly type="text" v-model="link"></b-input>
					<b-input-group-append>
						<copy-to-clipboard :text="link" @copy="copyLink"><b-button variant="outline-secondary" style="border-top-left-radius: 0;border-bottom-left-radius: 0;"><i class="fa fa-copy"></i> Copy Link</b-button></copy-to-clipboard>
					</b-input-group-append>
				</b-input-group>
              </b-form-group>

              <div>
              	<b-button variant="secondary" @click="goToStep('send_method')">Back</b-button>
              	<b-button variant="primary" class="float-right" @click="shareSocialLink()">Publish and Enable Tracking</b-button>
              </div>
            
        </div>
        <div v-if="step == 'show_link'">
            
              <b-form-group label="Link" description="This is the link to your SizzleDeck. You can share this link via email, social media or however you like. After this SizzleDeck has been published, this link will be available in the results area.">
              	<b-input-group>
					<b-input readonly type="text" v-model="link"></b-input>
					<b-input-group-append>
						<copy-to-clipboard :text="link" @copy="copyLink"><b-button variant="outline-secondary" style="border-top-left-radius: 0;border-bottom-left-radius: 0;"><i class="fa fa-copy"></i> Copy Link</b-button></copy-to-clipboard>
					</b-input-group-append>
				</b-input-group>
              </b-form-group>

              <div>
              	<b-button variant="secondary" @click="goToStep('send_via')">Back</b-button>
              	<b-button variant="primary" class="float-right" @click="shareLink()">Publish and Enable Tracking</b-button>
              </div>
            
        </div>
        <div v-if="step == 'show_contact_link'">
            
              <b-form-group label="Link" description="This is the link to your SizzleDeck. You can share this link via email, social media or however you like. After this SizzleDeck has been published, this link will be available in the results area.">
				<b-input-group>
					<b-input readonly type="text" :value="contactlink"></b-input>
					<b-input-group-append>
						<copy-to-clipboard :text="contactlink" @copy="copyLink"><b-button variant="outline-secondary" style="border-top-left-radius: 0;border-bottom-left-radius: 0;"><i class="fa fa-copy"></i> Copy Link</b-button></copy-to-clipboard>
					</b-input-group-append>
				</b-input-group>

              </b-form-group>

              <div>
              	<b-button variant="secondary" @click="goToStep('send_via')">Back</b-button>
              	<b-button variant="primary" class="float-right" @click="shareContactLink()">Publish and Enable Tracking</b-button>
              </div>
            
        </div>

        <!-- Preview -->
		<div v-if="step == 'preview'">

			<div class="text-center">
				<b-button variant="secondary" v-if="send_method === 'campaign'" :href="'/deck/preview/'+this.deckid" target="_blank">Preview Deck</b-button> 
				<b-button variant="secondary" v-if="send_method === 'single'" :href="'/deck/preview/'+this.deckid+'/'+this.contact_id" target="_blank">Preview Deck</b-button> 
				<b-button variant="secondary" v-if="send_via === 'both' || send_via === 'sms'" @click="previewSMS()">Preview SMS</b-button> 
				<b-button variant="secondary" v-if="send_via === 'both' || send_via === 'email'" @click="previewEmail()">Preview Email</b-button>
			</div>

			<div class="text-center">
				<b-button variant="primary" class="float-right" @click="scheduleSend()">Share Deck</b-button>
			</div>

			<div v-if="send_method=='single'">
				<b-button v-show="send_via === 'both'" variant="secondary" @click="goToStep('compose_email')">Back</b-button>
				<b-button v-show="send_via === 'sms'" variant="secondary" @click="goToStep('compose_sms')">Back</b-button>
			  	<b-button v-show="send_via === 'email'" variant="secondary" @click="goToStep('compose_email')">Back</b-button>
			</div>
			<div v-if="send_method=='campaign'">
				<b-button variant="secondary" @click="goToStep('choose_mailinglist')">Back</b-button>
			</div>

		</div>

		<b-modal id="sms-modal" size="lg" hide-footer title="SMS Preview">
			<div class="d-block" v-html="sms.preview"></div>
		</b-modal>
		<b-modal id="email-modal" size="lg" hide-footer :title="'Email Preview - Subject: '+email.preview_subject" style="height: ;">
			<div class="d-block">
				<fieldset class="border rounded" style="height: calc(100% - 47px);">
				<div class="bg-light border-bottom">
					<div class="px-2 pt-2"><strong>{{ email.from_name }}</strong></span></div>
					<div class="px-2">{{ email.subject }}</div>
					<div class="px-2" v-if="email.body"><span class="text-muted">{{ email.preheader ? email.preheader.substring(0, 63) : email.body.replace(/(<([^>]+)>)/gi, "").substring(0, 63) }}</span></div>
				</div>

				<iframe id="emailLivePreview" name="emailLivePreview" :src="(contact_id ? '/email/live-preview/'+deckid+'/'+contact_id : '/email/live-preview/'+deckid )" class="border-0 p-2 d-block w-100" style="height: calc(100vh - 400px)"></iframe>




				</fieldset>
			</div>
		</b-modal>


    </div>
</template>

<script>

import axios from 'axios';
import Noty from 'noty';
import debounce from 'debounce';
import CopyToClipboard from 'vue-copy-to-clipboard';

import { VueEditor, Quill } from "vue2-editor";

const Block = Quill.import("blots/block");
Block.tagName = "DIV";
Quill.register(Block, true);






export default {
	 components: {
    	CopyToClipboard,
  	},
    mounted() {
    	var vm = this;
    	// Get Share Link
		axios.post('/deck/getlink',{id: vm.deckid}).then(response => { vm.link = response.data; }).catch(function(error){ vm.handleError(error) });
    	
    	// Get Existing Details
    	axios.post('/deck/get',{id: vm.deckid}).then(response => {

			vm.sms.message = response.data.sms_message;
			vm.selected_email_template = response.data.email_template;
			vm.email.subject = response.data.email_subject;
			vm.email.preheader = response.data.email_preheader;
			vm.email.body = response.data.email_body;
			vm.email.button = response.data.email_button;
			vm.email.footer = response.data.email_footer;

			vm.og_meta.title = response.data.og_title;
			vm.og_meta.description = response.data.og_description;
			
 
			console.log(response.data);

			if(response.data.og_image_static){
				vm.og_meta.image = response.data.og_image_static;
  		}else if(response.data.og_image_dynamic){
				vm.og_meta.image = response.data.og_image_dynamic;
  		}else{
  			vm.og_meta.image = response.data.company_logo;
  		}

			vm.og_meta.domain = response.data.deck_domain.toUpperCase();




			console.log('og_meta',vm.og_meta);


			vm.renderString(vm.email.subject,'email_subject');
			vm.renderString(vm.email.preheader,'email_preheader');
			vm.renderString(vm.email.body,'email_body');

			// Get Defaults
			axios.get('/deck/defaults').then(response => {

				if(vm.sms.message == null){ vm.sms.message = 'Hi [firstname], here is some more info about '+response.data.company_name+' as requested.'; }


				/*
				if(vm.email.subject == null){ vm.email.subject = 'More Info for [firstname]'; }
				if(vm.email.body == null){ vm.email.body = 'Hi [firstname], \r\rGreat chatting. Here is some more info about '+response.data.company_name+' as discussed.'; }
				if(vm.email.button == null){ vm.email.button = 'Click to View'; }
				if(vm.email.footer == null){ 
					vm.email.footer = 'Any questions, just let me know.\r\rKind regards,\r\r'+response.data.first_name+' '+response.data.last_name+'\r';
					if(response.data.position){vm.email.footer = vm.email.footer+'\r'+response.data.position;}
					vm.email.footer = vm.email.footer+'\r'+response.data.company_name; 
				}
				*/

				vm.email.from_name = response.data.first_name+' '+response.data.last_name;
				vm.email.from_email = response.data.email;

				vm.use_capsule = response.data.use_capsule;

			}).catch(function(error){ vm.handleError(error) });

        }).catch(function(error){ vm.handleError(error) });

    	// Get Mailinglists
        axios.get('/contacts/mailinglist/list').then(response => {

          	vm.mailinglists = response.data.rows;

          	// Remove Empty Lists
            vm.mailinglists = vm.mailinglists.filter(function( mailinglist ) {
			    return mailinglist.size !== 0;
			});

            vm.$forceUpdate();
            vm.loaded_mailinglists = true;

        }).catch(function(error){ vm.handleError(error) });

    	// Get Email Templates
        axios.get('/email/templates/list-all').then(response => {

          	vm.email_templates = response.data.rows;

          	vm.$forceUpdate();


        }).catch(function(error){ vm.handleError(error) });

    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {

    	if(modalId == 'email-modal'){
    		vm.email_inital_load = false;
    	}

      console.log('Modal is about to be shown', bvEvent, modalId)
    })


    },
    props: [
        'deckid',
        'sms_credit_value',
        'email_credit_value',
        'current_credits',
    ],
    data: function(){
        return {                
        	step: 'og_meta',
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            send_method: null,
            send_via: null,
            link: null,
            addcontactform: {
				email: '',
				telephone: '',
				first_name: '',
				last_name: '',
				company_name: '',
			},
			contact_id: null,
			contact: {
				email: '',
				telephone: '',
				first_name: '',
				last_name: '',
				company_name: '',
			},
			use_capsule: false,
			loaded_mailinglists:false,
			mailinglists:[],
      selected_mailinglists:[],
			sms: {
				message:'',
				preview: '',
			},
			email_templates: [],
			selected_email_template:null,
			email:{
				subject: '',
				preheader: '',
				body: '',
				button: '',
				footer: '',
				custom_1: '',
				custom_2: '',
				custom_3: '',
				custom_4: '',
				preview: '',
				preview_subject: '',
				from_name: '',
				from_email: '',
				layout: '',
			},
			email_inital_load: false,
			rendered_string:[],
			og_meta:{
				title: '',
				description: '',
				image: '',
				domain: '',
			}
      };
    },
    methods:{
    	goToStep: function(step){
    		this.email_inital_load = false;
    		this.step = step;
    	},
    	shareLink: function(){
              
              var vm = this;

              axios.post('/deck/marksent',{id: vm.deckid}).then(response => {

               window.location.href = '/deck/results';

              }).catch(function(error){ vm.handleError(error) });

        },
    	shareSocialLink: function(){
              
              var vm = this;

			  axios.post('/deck/store',{
                id: vm.deckid,
                contact_id: '0',
                send_method: 'share'
              }).then(response => {

              	if(response.data.status == 'success'){

		              
	              axios.post('/deck/marksent',{id: vm.deckid,silent:true}).then(response => {

	               window.location.href = '/deck/link/'+vm.deckid;

	              }).catch(function(error){ vm.handleError(error) });

                }else{

                    new Noty({
                        text: response.data.message,
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                    }).show();

                }

              });

        },
        copyLink: function(result){
        	if(result){
        		this.showNoty('success','Link Copied to Clipboard',1000);
        	}
        },
    	shareContactLink: function(){
              
              var vm = this;

              axios.post('/deck/marksent',{id:vm.deckid,send_type:'contact_share',contact_id:vm.contact_id,silent:true}).then(response => {

               //window.location.href = '/deck/results';
               window.location.href = '/deck/link/'+vm.deckid;

              }).catch(function(error){ vm.handleError(error) });

        },
        addContact: function(evt){

        	var vm = this;

			evt.preventDefault();
			var post = this.addcontactform;
			post.ajax = true;

			axios.post('/contacts/contact/store',post).then(response => {

				if(response.data.status == 'success'){
					vm.selectContact(response.data.contact_id);
				}else{
					new Noty({
	                  text: response.data.message,
	                  type: 'error',
	                  theme: 'bootstrap-v4',
	                  layout: 'topCenter',
	                  timeout: 2000
	              	}).show();
				}

			}).catch(function(error){ vm.handleError(error) });

        },
        selectCapsuleContact: function(capsule_id){
        	var vm = this;
        	
        	axios.get('/contact/lookup/capsule/'+capsule_id).then(response => {

        		if(response.data.status == 'success'){
        			vm.contact_id = response.data.contact.id;
        			vm.contact = response.data.contact;
        			vm.send_method = 'single';
        			vm.step = 'send_via';
        		}else{
        			new Noty({
	                  text: response.data.message,
	                  type: 'error',
	                  theme: 'bootstrap-v4',
	                  layout: 'topCenter',
	                  timeout: 4000
	              	}).show();
        		}

        	}).catch(function(error){ vm.handleError(error) });
        },
        selectContact: function(id){
        	var vm = this;
        	vm.contact_id = id;
        	axios.get('/contact/lookup/id/'+id).then(response => {

        		if(response.data.status == 'success'){
        			vm.contact = response.data.contact;

			  axios.post('/deck/store',{
                id: vm.deckid,
                contact_id: vm.contact.id,
                send_method: 'single'
              }).then(response => {

              	if(response.data.status == 'success'){

		              vm.send_method = 'single';
		        			vm.step = 'send_via';
		        			
		        			vm.renderString(vm.email.subject,'email_subject');
		        			vm.renderString(vm.email.preheader,'email_preheader');
		        			vm.renderString(vm.email.body,'email_body');
		        			// skip send via step
		        			//vm.send_via = 'sms';
		        			//vm.step = 'compose_sms';

                }else{

                    new Noty({
                        text: response.data.message,
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                    }).show();

                }

              }).catch(function(error){ vm.handleError(error) });



        		}else{
        			new Noty({
	                  text: response.data.message,
	                  type: 'error',
	                  theme: 'bootstrap-v4',
	                  layout: 'topCenter',
	                  timeout: 4000
	              	}).show();
        		}

        	}).catch(function(error){ vm.handleError(error) });
        },
        showNoMailinglistsError: function(){
        	new Noty({
                      text: `<div class="text-center"><h5>Oops, no mailing lists found.</h5>
                      <p><a class="btn btn-primary mt-2" href="/contacts/mailinglist/new">Click here to create a mailinglist.</a></p>
                      <p>Your deck has been saved as a draft to return to after you have created your list.</p>
                      </div>
                      `,
                      type: 'error',
                      theme: 'bootstrap-v4',
                      layout: 'topCenter',
                      timeout: 19000
                    }).show();
        },
        selectMailingLists: function(){
        	var vm = this;
        	if(vm.selected_mailinglists.length == 0){
    	        	new Noty({
                      text: 'Please select one or more Mailing Lists to continue.',
                      type: 'error',
                      theme: 'bootstrap-v4',
                      layout: 'topCenter',
                      timeout: 2000
                    }).show();
    	        	return;
    	    }
              
            vm.send_method = 'campaign';           
            vm.step = 'preview';

        },
        selectSendMethod: function(method){
        	var vm = this;
        	switch(method){
        		case 'single':
        			vm.send_method = 'single';
        		break
        		case 'campaign':
        			vm.send_method = 'campaign';
        		break
        	}

        },
        selectSendVia: function(method){
        	var vm = this;
        	vm.send_via = method;

      	if((
					 vm.send_via == 'email' || 
					 vm.send_via == 'sms'   || 
					 vm.send_via == 'both'
        		) && (vm.current_credits == 0)){
        		 new Noty({
                        text: `
                        <div class="text-center"><h5>Oops! You are out of SizzleDeck Credits!</h5>
                        <p>To send your link using SizzleDeck's Email/SMS platform you need to buy a credits bundle. </p>
                        <a class="btn btn-primary" href="/billing/credits">Click here to buy Credits</a></div>
                        `,
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 99000
                    }).show();

        		return;

        	}

        	switch(method){
        		case 'email':
        			vm.step = 'compose_email';
        			vm.updateEmailPreview();
        		break
        		case 'sms':
        			vm.step = 'compose_sms';
        		break
        		case 'both':
        			vm.step = 'compose_sms';
        		break
        	}

        	// Display Notice if out of Credits

        	//console.log('vm.current_credits',vm.current_credits);
        	

  
                   


       
        },
        saveSMS: function(){
        	
        	var vm = this;
        	axios.post('/deck/store',{
                id: vm.deckid,
                sms_message: vm.sms.message,
              }).then(response => {

              	if(response.data.status == 'success'){

              		if(vm.send_via == 'sms'){

              			if(vm.send_method == 'single'){
              				vm.goToStep('preview');
              			}
              			if(vm.send_method == 'campaign'){
              				vm.goToStep('choose_mailinglist');
              			}
              			

              		}else{
              			vm.goToStep('compose_email');
              		}
                  

                }else{

                    new Noty({
                        text: response.data.message,
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                    }).show();

                }

              }).catch(function(error){ vm.handleError(error) });

        },
        previewSMS: function(){

              var vm = this;

              axios.post('/deck/sms-preview',{deck_id:vm.deckid,send_type:vm.send_method,contact_id:vm.contact_id,mailinglists:vm.selected_mailinglists}).then(response => {

                vm.sms.preview = response.data.sms_message;

                vm.$nextTick(function () {
  					vm.$bvModal.show('sms-modal');
				});

              }).catch(function(error){ vm.handleError(error) });

        },
        saveEmail: function(){

        	var vm = this;
        	axios.post('/deck/store',{
                  id: vm.deckid,
                  email_template: vm.selected_email_template,
                  email_subject: vm.email.subject,
                  email_preheader: vm.email.preheader,
                  email_body: vm.email.body,
                  email_button: vm.email.button,
                  email_footer: vm.email.footer,
                  email_custom_1: vm.email.custom_1,
                  email_custom_2: vm.email.custom_2,
                  email_custom_3: vm.email.custom_3,
                  email_custom_4: vm.email.custom_4
              }).then(response => {

              	if(response.data.status == 'success'){

                        if(vm.send_method == 'single'){
              				vm.goToStep('preview');
              			}
              			if(vm.send_method == 'campaign'){
              				vm.goToStep('choose_mailinglist');
              			}

                }else{

                    new Noty({
                        text: response.data.message,
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                    }).show();

                }

              }).catch(function(error){ vm.handleError(error) });

        },
        previewEmail: function(){

              var vm = this;

              axios.post('/deck/email-preview',{deck_id:vm.deckid,send_type:vm.send_method,contact_id:vm.contact_id,mailinglists:vm.selected_mailinglists}).then(response => {

                vm.email.preview = response.data.email_message;
                vm.email.preview_subject = response.data.email_subject;

                vm.$nextTick(function () {
  					vm.$bvModal.show('email-modal');
				});

                

              }).catch(function(error){ vm.handleError(error) });

        },
        scheduleSend: function(){

              	var vm = this;

              	if(vm.send_method == 'single'){
              		var post_vars = {
              				id : vm.deckid,
              				type : 'single',
              				via : vm.send_via,
              				contact_id : vm.contact_id
              			};
              	}
              	if(vm.send_method == 'campaign'){
              		var post_vars = {
              				id : vm.deckid,
              				type : 'bulk',
              				via : vm.send_via,
              				mailinglists : vm.selected_mailinglists
              			};
              	}

                axios.post('/deck/send',post_vars).then(response => {

                      if(response.data.status == 'success'){

                          window.location.href = '/deck/results';
                      
                      }else{

                          new Noty({
                              text: response.data.message,
                              type: response.data.status,
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: 5000,
                          }).show();

                      }

                  }).catch(function(error){ vm.handleError(error) });

        },
        handleError: function(error){

            if(error.response.status == '419'){
              this.showLoggedOutNoty();
            }else{
              this.showGeneralErrorNoty();
          	}

        },
        showNoty: function(type='warning',message='',timeout=false){
	        new Noty({
	                  text: message,
	                  type: type,
	                  theme: 'bootstrap-v4',
	                  layout: 'topCenter',
	                  timeout: timeout
	              }).show();
        },
        showGeneralErrorNoty: function(){
	        new Noty({
	                  text: 'There has been an error. Please <a href="javascript:window.location.reload(true)">refresh this page</a> and try again.',
	                  type: 'error',
	                  theme: 'bootstrap-v4',
	                  layout: 'topCenter',
	                  timeout: false
	              }).show();
        },
        showLoggedOutNoty: function(){
        	new Noty({
	            text: 'You have been logged out due to inactivity. Please <a href="javascript:window.location.reload(true)">refresh this page</a> to login.',
	            type: 'error',
	            theme: 'bootstrap-v4',
	            layout: 'topCenter',
	            timeout: false
	        }).show();
        },      
        getEmailTemplate: function(){
        	var vm = this;
        	axios.get('/email/get/' + vm.selected_email_template).then(response => {

          	vm.email.layout = vm.email.layout ? vm.email.layout : response.data.layout;
          	vm.email.body = vm.email.body ? vm.email.body : response.data.body;
          	vm.email.preheader = vm.email.preheader ? vm.email.preheader : response.data.preheader;
						vm.email.subject = vm.email.subject ? vm.email.subject : response.data.subject;
						vm.email.button = vm.email.button ? vm.email.button : response.data.button;
						vm.email.footer = vm.email.footer ? vm.email.footer : response.data.footer;
						vm.email.custom_1 = vm.email.custom_1 ? vm.email.custom_1 : response.data.custom_1;
						vm.email.custom_2 = vm.email.custom_2 ? vm.email.custom_2 : response.data.custom_2;
						vm.email.custom_3 = vm.email.custom_3 ? vm.email.custom_3 : response.data.custom_3;
						vm.email.custom_4 = vm.email.custom_4 ? vm.email.custom_4 : response.data.custom_4;				

						vm.renderString(vm.email.subject,'email_subject');
						vm.renderString(vm.email.preheader,'email_preheader');
						vm.renderString(vm.email.body,'email_body');

          }).catch(function(error){ vm.handleError(error) });
        },
		initalLoadEmailPreview: function(){

			var vm = this;

      vm.$nextTick(function () {
  				
				if(!vm.email_inital_load){
					vm.$refs.emailpreviewform.submit();
		    		vm.email_inital_load = true;
		    	}else{

		    		/* Keep iframe centered (for wider emails) */
		    		var iframe_width = vm.$refs.emailPreviewIframe.scrollWidth;
		    		var content_width = vm.$refs.emailPreviewIframe.contentWindow.document.documentElement.scrollWidth;
		    		var scroll_amount = (content_width - iframe_width) / 2;

		    		vm.$refs.emailPreviewIframe.contentWindow.document.documentElement.scrollLeft = scroll_amount;
		    	}

			});

		},
    updateEmailPreview: function(){
        	var vm = this;
				if(vm.$refs.emailpreviewform !== undefined){
						vm.$nextTick(function () {
	    					vm.$refs.emailpreviewform.submit();
	    					vm.email_inital_load = true;
	    					
	    				});
	    		}
    },

    renderString: function(string,key){

			var vm = this;

    	vm.rendered_string[key] = string;      

      axios.post('/email/render-string',{
                  string: string,
                  contact: vm.contact_id,
                  deck: vm.deckid,
                  
              }).then(response => {
      	
    		vm.rendered_string[key] = response.data;
				
      }).catch(function(error){ vm.handleError(error) });

     },

     debounceRenderString: debounce(function (string,key) {
        this.renderString(string,key);
      }, 600),

/*OG META*/
      launchSetOGimage: function(){
        this.$refs['crop-ogimage-modal'].show();
      },
      setDeckOgImage: function(image){
      	this.og_meta.image = image;
      },
      saveOG: function(){

      		var vm = this;

            const url = `/deck/store`;

            axios.post(url,{id:vm.deckid,og_image_static:vm.og_meta.image,og_title:vm.og_meta.title,og_description:vm.og_meta.description}).then(response => {
               this.img = response.data.payload.og_image_static;


                new Noty({
                        text: 'Share settings updated',
                        type: 'success',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                }).show();

                vm.goToStep('send_method');

            }).catch(() => console.warn('Oh. Something went wrong with saveOG'));

      },

/*END OG META*/


    },
    watch:{
    	email_templates: {
    		handler: function() {
    			var vm = this;   			
	    		if(!vm.selected_email_template){
	          		vm.selected_email_template = vm.email_templates[0].id;
	          	}
          },
    	},
    	selected_email_template: {
    		handler: function() {
    			var vm = this;
    			if(vm.selected_email_template){
    				vm.getEmailTemplate();
				}
    		},
    	},
    	email: {
    		handler: function() {
    			var vm = this;

    			vm.$nextTick(function () {
						vm.updateEmailPreview();
						vm.renderString(vm.email.subject,'email_subject');
	    			vm.renderString(vm.email.preheader,'email_preheader');
	    			vm.debounceRenderString(vm.email.body,'email_body');
	    		});
    		},     
    		deep: true
    	},
    },
    computed: {
    	contactlink: function(){
    	 	return this.link + '/' + this.contact_id; 
    	}
    }
}

</script>
<style type="text/css">
	.sms-img-wrap{
		width: 100%;
		padding-bottom: 52%;
		background-position: center center;
		background-size: cover;
		background-repeat: no-repeat;
	}
</style>